import React, { useEffect, useState } from 'react'
import '../../cssHelper/helper.css'
import './Sidebar.css'
import youtubeLogo from '../../assets/youtube-logo.png'
import { setThisSidebar, setCategory } from '../../redux/redux'
import { useDispatch, useSelector } from 'react-redux'
import { apiKey, baseUrl } from '../../Constants/Constants'

function Sidebar(props) {

    const thisSidebar = useSelector((state) => state.youtube.thisSidebar);
    const dispatch = useDispatch();
    const [subscribes, setSubscribes] = useState();

    useEffect(() => {
        fetch(`    https://youtube.googleapis.com/youtube/v3/channels?part=snippet&id=UCLbdVvreihwZRL6kwuEUYsA%2CUC2bNrKQbJLphxNCd6BSnTkA%2CUCQzdMyuz0Lf4zo4uGcEujFw&maxResults=20&key=${apiKey}`)
            .then(result => result.json())
            .then(data => {
                console.log(data.items);
                setSubscribes(data.items)
            })
            .catch(err => console.log(err));
    }, [])
    return (
        <div className={`Sidebar flex flex-col text-3 ${props.video ? 'w-full' : 'sidebar-w'}`}>
            <div className={`sidebar-header flex gap-05 a-center pl-1 ease-4 p-block-1 span ${props.video ? 'fixed top this-sidebar' : ''}`}>
                {
                    thisSidebar ? (
                        <span onClick={() => dispatch(setThisSidebar(false))} class="material-symbols-rounded pointer r-50">
                            close
                        </span>
                    ) : (
                        <span class="material-symbols-rounded pointer r-50">
                            menu
                        </span>
                    )
                }
                <div className="youtube-logo-hero flex gap-05 a-center">
                    <img src='https://www.edigitalagency.com.au/wp-content/uploads/Youtube-logo-white-png.png' alt="Youtube" className='youtube-logo cover' />
                    <sup>IN</sup>
                </div>
            </div>
            <div className={`sidebar-scroller-wrapper scroll-hidden ${props.video ? 'mt-5' : ''}`}>
                <div className="sidebar-scroll scroll-y scroll-hidden-x">
                    {/* main navs  */}
                    <div className="main-navs p-inline-1">
                        <ul className="sidebar-navs flex flex-col span pb-1">
                            <li onClick={() => dispatch(setCategory(''))} className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 bold-500">
                                <span class="material-symbols-rounded">
                                    home
                                </span>
                                <p className="side-nav font-sm">
                                    Home
                                </p>
                            </li>
                            <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500">
                                <span class="material-symbols-rounded">
                                    blur_short
                                </span>
                                <p className="side-nav font-sm">
                                    Shorts
                                </p>
                            </li>
                            <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500">
                                <span class="material-symbols-rounded">
                                    subscriptions
                                </span>
                                <p className="side-nav font-sm">
                                    Subcriptions
                                </p>
                            </li>
                        </ul>
                    </div>
                    {/* user navs  */}
                    <div className="user-navs p-inline-1 pt-1">
                        <ul className="sidebar-navs flex flex-col span pb-1">
                            <p className="font-sm bold-600 pl-1 side-head-lead">
                                You
                            </p>
                            <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500 mt-1">
                                <span class="material-symbols-rounded">
                                    account_box
                                </span>
                                <p className="side-nav font-sm">
                                    Your channel
                                </p>
                            </li>
                            <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500">
                                <span class="material-symbols-rounded">
                                    history
                                </span>
                                <p className="side-nav font-sm">
                                    History
                                </p>
                            </li>
                            <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500">
                                <span class="material-symbols-rounded">
                                    subscriptions
                                </span>
                                <p className="side-nav font-sm">
                                    Playlists
                                </p>
                            </li>
                            <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500">
                                <span class="material-symbols-rounded">
                                    smart_display
                                </span>
                                <p className="side-nav font-sm">
                                    Your Videos
                                </p>
                            </li>
                            <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500">
                                <span class="material-symbols-rounded">
                                    schedule
                                </span>
                                <p className="side-nav font-sm">
                                    Watch Later
                                </p>
                            </li>
                            <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500">
                                <span class="material-symbols-rounded">
                                    thumb_up
                                </span>
                                <p className="side-nav font-sm">
                                    Liked videos
                                </p>
                            </li>
                        </ul>
                    </div>
                    {/* Subcriptions  */}
                    <div className="subcription-navs p-inline-1 pt-1">
                        <ul className="sidebar-navs flex flex-col span pb-1">
                            <p className="font-sm bold-600 pl-1 mb-1 side-head-lead">
                                Subcriptions
                            </p>
                            {
                                subscribes && subscribes.length > 0 ? (
                                    subscribes.map((subscribe) => (
                                        <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500">
                                            <img src={subscribe.snippet ? subscribe.snippet.thumbnails.high.url : ''} alt="" className="img-3 cover r-50" />
                                            {subscribe.snippet.title}
                                        </li>
                                    ))
                                ) : ''
                            }
                        </ul>
                    </div>
                    {/* Explore  */}
                    <div className="explore-navs p-inline-1 pt-1">
                        <ul className="sidebar-navs flex flex-col span pb-1">
                            <p className="font-sm bold-600 pl-1 side-head-lead">
                                Explore
                            </p>
                            <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500 mt-1">
                                <span class="material-symbols-rounded">
                                    trending_up
                                </span>
                                <p className="side-nav font-sm">
                                    Trending
                                </p>
                            </li>
                            <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500">
                                <span class="material-symbols-rounded">
                                    local_mall
                                </span>
                                <p className="side-nav font-sm">
                                    Shopping
                                </p>
                            </li>
                            <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500">
                                <span class="material-symbols-rounded">
                                    music_note
                                </span>
                                <p className="side-nav font-sm">
                                    Music
                                </p>
                            </li>
                            <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500">
                                <span class="material-symbols-rounded">
                                    movie
                                </span>
                                <p className="side-nav font-sm">
                                    Films
                                </p>
                            </li>
                            <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500">
                                <span class="material-symbols-rounded">
                                    sensors
                                </span>
                                <p className="side-nav font-sm">
                                    Live
                                </p>
                            </li>
                            <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500">
                                <span class="material-symbols-rounded">
                                    stadia_controller
                                </span>
                                <p className="side-nav font-sm">
                                    Gaming
                                </p>
                            </li>
                            <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500">
                                <span class="material-symbols-rounded">
                                    newsmode
                                </span>
                                <p className="side-nav font-sm">
                                    News
                                </p>
                            </li>
                            <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500">
                                <span class="material-symbols-rounded">
                                    trophy
                                </span>
                                <p className="side-nav font-sm">
                                    Sport
                                </p>
                            </li>
                            <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500">
                                <span class="material-symbols-rounded">
                                    lightbulb
                                </span>
                                <p className="side-nav font-sm">
                                    Courses
                                </p>
                            </li>
                            <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500">
                                <span class="material-symbols-rounded">
                                    styler
                                </span>
                                <p className="side-nav font-sm">
                                    Fashion & beauty
                                </p>
                            </li>
                            <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500">
                                <span class="material-symbols-rounded">
                                    podcasts
                                </span>
                                <p className="side-nav font-sm">
                                    Podacasts
                                </p>
                            </li>
                        </ul>
                    </div>
                    {/* more from youtube  */}
                    <div className="user-navs p-inline-1 pt-1">
                        <ul className="sidebar-navs flex flex-col span pb-1">
                            <p className="font-sm bold-600 pl-1 side-head-lead">
                                More from Youtube
                            </p>
                            <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500 mt-1">
                                <span class="material-symbols-rounded">
                                    home
                                </span>
                                <p className="side-nav font-sm">
                                    Youtube Premium
                                </p>
                            </li>
                            <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500">
                                <span class="material-symbols-rounded">
                                    home
                                </span>
                                <p className="side-nav font-sm">
                                    Youtube Studio
                                </p>
                            </li>
                            <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500">
                                <span class="material-symbols-rounded">
                                    subscriptions
                                </span>
                                <p className="side-nav font-sm">
                                    Youtube Music
                                </p>
                            </li>
                            <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500">
                                <span class="material-symbols-rounded">
                                    subscriptions
                                </span>
                                <p className="side-nav font-sm">
                                    Youtube Kids
                                </p>
                            </li>
                        </ul>
                    </div>
                    {/* user controls  */}
                    <div className="user-navs p-inline-1 pt-1">
                        <ul className="sidebar-navs flex flex-col span pb-1">
                            <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500">
                                <span class="material-symbols-rounded">
                                    settings
                                </span>
                                <p className="side-nav font-sm">
                                    Settings
                                </p>
                            </li>
                            <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500">
                                <span class="material-symbols-rounded">
                                    flag
                                </span>
                                <p className="side-nav font-sm">
                                    Report history
                                </p>
                            </li>
                            <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500">
                                <span class="material-symbols-rounded">
                                    help
                                </span>
                                <p className="side-nav font-sm">
                                    Help
                                </p>
                            </li>
                            <li className="flex gap-1 p-inline-05 a-center ease-4 height pointer r-10 font-sm bold-500">
                                <span class="material-symbols-rounded">
                                    forum
                                </span>
                                <p className="side-nav font-sm">
                                    Send feedback
                                </p>
                            </li>
                        </ul>
                    </div>
                    <div className="sidebar-summary flex flex-col gap-1 pt-1 pl-2 pb-1 text-2 font-xs">
                        <p>
                            About Press Copyright  <br />
                            Contact us Creators <br />
                            Advertise Developers
                        </p>
                        <p>
                            Terms Privacy Policy & Safety <br />
                            How YouTube works <br />
                            Test new features
                        </p>
                        <p>
                            © 2024 Google LLC
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Sidebar
